import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, TwitterIcon, YoutubeIcon, ArrowRightIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-neutral-dark text-white pt-12 pb-6" data-id="element-61">
      <div className="container mx-auto px-4 md:px-6" data-id="element-62">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-63">
          <div data-id="element-64">
            <h3 className="text-xl font-display font-bold mb-4" data-id="element-65">
              <span className="text-toronto-blue" data-id="element-66">Market Research</span>
              <span className="text-canada-red" data-id="element-67"> Toronto</span>
            </h3>
            <p className="text-neutral-light mb-4" data-id="element-68">
              Global insight. Local intelligence.
            </p>
            <div className="flex space-x-4" data-id="element-69">
              <a href="#" className="text-white hover:text-toronto-blue transition-colors" data-id="element-70">
                <LinkedinIcon size={20} data-id="element-71" />
              </a>
              <a href="#" className="text-white hover:text-toronto-blue transition-colors" data-id="element-72">
                <TwitterIcon size={20} data-id="element-73" />
              </a>
              <a href="#" className="text-white hover:text-toronto-blue transition-colors" data-id="element-74">
                <YoutubeIcon size={20} data-id="element-75" />
              </a>
            </div>
          </div>
          <div data-id="element-76">
            <h4 className="text-lg font-semibold mb-4" data-id="element-77">Quick Links</h4>
            <ul className="space-y-2" data-id="element-78">
              <li data-id="element-79">
                <Link to="/about" className="text-neutral-light hover:text-toronto-blue transition-colors" data-id="element-80">
                  About Us
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/services" className="text-neutral-light hover:text-toronto-blue transition-colors" data-id="element-82">
                  Services
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/industries" className="text-neutral-light hover:text-toronto-blue transition-colors" data-id="element-84">
                  Industries
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/case-studies" className="text-neutral-light hover:text-toronto-blue transition-colors" data-id="element-86">
                  Case Studies
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/insights" className="text-neutral-light hover:text-toronto-blue transition-colors" data-id="element-88">
                  Insights
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-89">
            <h4 className="text-lg font-semibold mb-4" data-id="element-90">Contact</h4>
            <address className="not-italic text-neutral-light" data-id="element-91">
              <p data-id="element-92">123 Research Avenue</p>
              <p data-id="element-93">Toronto, ON M5V 2K4</p>
              <p className="mt-2" data-id="element-94">info@marketresearchtoronto.com</p>
              <p data-id="element-95">+1 (416) 555-1234</p>
            </address>
          </div>
          <div data-id="element-96">
            <h4 className="text-lg font-semibold mb-4" data-id="element-97">Newsletter</h4>
            <p className="text-neutral-light mb-4" data-id="element-98">
              Stay updated with our latest insights and news.
            </p>
            <form className="flex" data-id="element-99">
              <input type="email" placeholder="Your email" className="px-4 py-2 w-full text-neutral-dark rounded-l focus:outline-none" data-id="element-100" />
              <button type="submit" className="bg-toronto-blue text-white px-4 py-2 rounded-r hover:bg-blue-700 transition-colors" data-id="element-101">
                <ArrowRightIcon size={20} data-id="element-102" />
              </button>
            </form>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-6 mt-6 text-sm text-neutral-light" data-id="element-103">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-104">
            <p data-id="element-105">
              &copy; {new Date().getFullYear()} Market Research Toronto. All
              rights reserved.
            </p>
            <div className="flex space-x-4 mt-4 md:mt-0" data-id="element-106">
              <Link to="/privacy-policy" className="hover:text-toronto-blue transition-colors" data-id="element-107">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-toronto-blue transition-colors" data-id="element-108">
                Terms of Service
              </Link>
            </div>
          </div>
          <div className="mt-4 flex flex-wrap gap-2 justify-center md:justify-start" data-id="element-109">
            <span className="bg-gray-700 text-xs px-2 py-1 rounded" data-id="element-110">
              ISO 20252 Certified
            </span>
            <span className="bg-gray-700 text-xs px-2 py-1 rounded" data-id="element-111">
              ESOMAR Member
            </span>
            <span className="bg-gray-700 text-xs px-2 py-1 rounded" data-id="element-112">
              MRIA Gold Seal
            </span>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;